import React from "react";

const JQuery_Add = () => {
  return (
    <div>
      <h1>JQuery_Add</h1>
      <p>Placeholder component for: "JQuery_Add"</p>
    </div>
  );
};

export default JQuery_Add;
